import { render, staticRenderFns } from "./event-details.html?vue&type=template&id=2fd1e2be&scoped=true&external"
import script from "./event-details.vue?vue&type=script&lang=js"
export * from "./event-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1e2be",
  null
  
)

export default component.exports